import axios from 'axios';

export const clientsUsageApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/clients-usage`,
    headers: {
        'Content-Type': 'application/json'
    }
})
